import AuthRoute from "routes/AuthRoute";
// import { RedirectFromLogin } from "../RedirectFromLogin";
import { authGuardLoader } from "routes/loaders/authGuardLoader";

const authRoutes = [
  {
    path: "/login",
    loader: authGuardLoader,
    lazy: async () => {
      const [loginMod, errorMod] = await Promise.all([
        import("views/Authentication/Login/new-login-flow"),
        import("views/ErrorPage"),
      ]);

      const NewLogin = loginMod.default; // handles default or named
      const ErrorPage = errorMod.default;

      return {
        Component: () => (
          // <RedirectFromLogin>
          <AuthRoute>
            <NewLogin />
          </AuthRoute>
          // </RedirectFromLogin>
        ),
        ErrorBoundary: ErrorPage,
      };
    },
  },

  {
    path: "/signup",
    lazy: async () => {
      const [loginMod, errorMod] = await Promise.all([
        import("views/Authentication/Login/new-login-flow"),
        import("views/ErrorPage"),
      ]);

      const NewLogin = loginMod.default;
      const ErrorPage = errorMod.default;

      return {
        Component: () => (
          <AuthRoute>
            <NewLogin />
          </AuthRoute>
        ),
        ErrorBoundary: ErrorPage,
      };
    },
  },

  {
    path: "/onboarding",
    lazy: async () => {
      const [onboardingMod, errorMod] = await Promise.all([
        import("components/onboardingSession/FirstOnboardingSessionPage"),
        import("views/ErrorPage"),
      ]);
      // // @ts-ignore
      // const FirstOnboardingSessionPage =
      //   // @ts-ignore
      //   onboardingMod.FirstOnboardingSessionPage;
      // const ErrorPage = errorMod.default;
      const FirstOnboardingSessionPage = onboardingMod.default;
      const ErrorPage = errorMod.default;

      return {
        Component: FirstOnboardingSessionPage,
        ErrorBoundary: ErrorPage,
      };
    },
  },
];

export default authRoutes;
